<template>
  <vue-daum-postcode @complete="complete"/>
</template>

<script>
    import { mapState } from 'vuex'
    import { nameByConstMixin } from '@/lib/mixins'
    import { VueDaumPostcode } from "vue-daum-postcode"

    export default {
        name: 'location',
        
        data () {
            return {
                result: {}
            }
        },
        methods: {
            complete(event){
                this.closeModal(event);
                
            },
            closeModal(event) {
                this.$emit('closeEvent', event);
            },
        },
        computed: {
            ...mapState(['account'])
        },
        mounted () {
            //this.setApiInfo();
        },
        components: {
            VueDaumPostcode
        }
    }
</script>

<style scoped>
</style>